import React from 'react';
import './Loader.scss';
import loaderImg from '../../images/logo/loader.png';

const Loader = () => {
  return (
    <div className="Loader">
      <img src={loaderImg} alt="Loading..." className="loader-image" />
    </div>
  );
};

export default Loader;
